import { Types } from '@store/types';

const initialState = [];

const MaterialReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_MATERIAL_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default MaterialReducer;
